import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { MasterService } from "../master/services/master.service";
import { PersonSelectorService } from "./personselector.service";
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from "../../shared/services/user.service";
import { SchoolService } from "../../shared/services/school.service";
import { HttpclientService } from "../../shared";
import { LocalstorageService } from "../../shared/services/localstorage.service";
import { SchoolselectorService } from "../schoolselector/schoolselectorservice.service";

declare var $: any;

@Component({
	selector: "caass-personfilterselector",
	templateUrl: "./personselector.filter.component.html",
	styleUrls: ["./personselector.css"],
})
export class PersonSelectorFilterComponent implements OnDestroy, OnInit {
	@Input()
	dialogForm: boolean = false;
	@Input()
	AudienceID: number = 1;
	@Input()
	ShowAllSchools: boolean = true;

	@Input()
	InputApplicationItemID: any = "";

	@Input() InputSchoolID: any = 0;

	@Input() UpdateSchoolSelector: boolean = true;

	SchoolLoading: any = false;
	DynamicGroupLoading: any = false;
	DynamicValueLoading: any = false;

	lstSchool: any;
	lstDynamicGroup: any;
	lstDynamicGroupValue: any;
	applicationItemID: any;
	subscription: Subscription;
	audienceIdChangedSubscription: Subscription;
	initialparams: any;

	public filterOptions = {
		SchoolID: 0,
		StatusID: 1,
		SortByID: 1,
		DynamicGroupValueID: 0,
		DynamicGroup: {
			DynamicGroupID: 0,
			DynamicGroupName: "",
		},
		Criteria: "",
		WorkflowRoleID: -2, //All
	};

	HideGroupValue = 0;

	lstStatus: any = [
		{
			StatusID: 2,
			StatusDesc: "All",
		},
		{
			StatusID: 1,
			StatusDesc: "Active",
		},
		{
			StatusID: 0,
			StatusDesc: "Inactive",
		},
	];

	lstSortBy: any = [
		{
			SortByID: 1,
			SortByDesc: "School Name",
		},
		{
			SortByID: 2,
			SortByDesc: "School Number",
		},
	];

	//
	// SBM
	//
	IsSBM: any = false;
	lstWorkflowRole: any = [];

	constructor(
		private masterService: MasterService,
		private localstorageService: LocalstorageService,
		private personSelectorService: PersonSelectorService,
		private schoolService: SchoolService,
		private userService: UserService,
		private httpclientService: HttpclientService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private schoolSelectorService: SchoolselectorService
	) {}

	private setApplicationItemID() {
		var applicationItem = this.masterService.getCurrentApplicationItem();
		if (applicationItem) {
			this.applicationItemID = applicationItem.ApplicationItemID;
		} else {
			this.applicationItemID = this.InputApplicationItemID;
		}

		/* var r = this.activatedRoute;
    while (r.firstChild) r = r.firstChild;
    var itemID = r.snapshot.data.applicationItemID;
    if (itemID) {
          
      this.applicationItemID=itemID;
    }else{
      this.applicationItemID=null
    } */
	}

	private loadSBMOption() {
		var result = this.personSelectorService.GetSBMPreference();
		result.subscribe(
			(response) => {
				var Pref = response[0]; //There should only be 1 district level preference

				this.IsSBM = Number(Pref.KeyValue) == 1 ? true : false;

				if (this.IsSBM == true) {
					this.loadWorkflowRoles();
				}
			},
			(error) => {}
		);
	}

	private loadWorkflowRoles() {
		var result = this.personSelectorService.PersonSelectorRoleGetList();
		result.subscribe(
			(response) => {
				this.lstWorkflowRole = response;

				if (this.lstWorkflowRole.length > 0) {
					this.filterOptions.WorkflowRoleID = this.lstWorkflowRole[0].WorkflowRoleID;
				}
			},
			(error) => {}
		);
	}

	private loadDynamicGroupValue() {
		this.DynamicValueLoading = true;

		var result = this.personSelectorService.loadDynamicGroupValue(this.filterOptions.SchoolID, this.filterOptions.DynamicGroup.DynamicGroupID);
		result.subscribe(
			(response) => {
				this.lstDynamicGroupValue = response;

				this.filterOptions.DynamicGroupValueID = 0;

				if (this.initialparams != undefined && this.initialparams.dynamicGroupValueID != undefined) {
					var found = false;
					for (var i = 0; i < this.lstDynamicGroupValue.length; i++) {
						var next = this.lstDynamicGroupValue[i];

						if (next.DynamicGroupValueID == this.initialparams.dynamicGroupValueID) {
							found = true;
							break;
						}
					}
					if (found == true) {
						this.filterOptions.DynamicGroupValueID = this.initialparams.dynamicGroupValueID;
					}
				}

				if (this.filterOptions.DynamicGroupValueID <= 0) {
					if (this.lstDynamicGroupValue.length > 0) {
						this.filterOptions.DynamicGroupValueID = this.lstDynamicGroupValue[0].DynamicGroupValueID;
					}
				}

				this.DynamicValueLoading = false;

				this.filterChanged();
			},
			(error) => {
				this.DynamicValueLoading = false;
			}
		);
	}

	private loadDynamicGroup() {
		this.DynamicGroupLoading = true;

		var result = this.personSelectorService.loadDynamicGroup(this.AudienceID);
		result.subscribe(
			(response) => {
				this.lstDynamicGroup = response;

				if (this.initialparams && this.initialparams.dynamicGroupID && this.initialparams.dynamicGroupID > 0) {
					this.filterOptions.DynamicGroup.DynamicGroupID = this.initialparams.dynamicGroupID;
					this.filterOptions.DynamicGroup.DynamicGroupName = this.initialparams.dynamicGroupName;
				} else {
					this.filterOptions.DynamicGroup.DynamicGroupID = this.lstDynamicGroup[0].DynamicGroupID;
					this.filterOptions.DynamicGroup.DynamicGroupName = this.lstDynamicGroup[0].DynamicGroupName;
				}

				if (this.InputSchoolID > 0) {
					this.filterOptions.DynamicGroup.DynamicGroupID = 1;
					this.filterOptions.DynamicGroup.DynamicGroupName = "School";
					this.filterOptions.DynamicGroupValueID = this.InputSchoolID;
				}

				//
				// Dynamic Group not in list
				//
				var found = false;
				for (var i = 0; i < this.lstDynamicGroup.length; i++) {
					var next = this.lstDynamicGroup[i];

					if (next.DynamicGroupID == this.filterOptions.DynamicGroup.DynamicGroupID) {
						found = true;
						break;
					}
				}

				if (!found) {
					this.filterOptions.DynamicGroup.DynamicGroupID = this.lstDynamicGroup[0].DynamicGroupID;
					this.filterOptions.DynamicGroup.DynamicGroupName = this.lstDynamicGroup[0].DynamicGroupName;
				}

				this.DynamicGroupLoading = false;

				this.loadDynamicGroupValue();
			},
			(error) => {
				this.DynamicGroupLoading = false;
			}
		);
	}
	private loadSchoolist(applicationItemID) {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolList(applicationItemID);
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				if (this.lstSchool.length > 1 && this.ShowAllSchools && this.userService.getCurrentUser().userID != 0) {
					this.lstSchool.push({
						SchoolID: 0,
						SchoolFullName: "All Schools",
					});
				}
				if (this.lstSchool.length == 1) {
					this.filterOptions.SchoolID = this.lstSchool[0].SchoolID;
					//this.loadDynamicGroup();
				}
				if (this.initialparams) {
					if (this.initialparams.SortByID != undefined) {
						this.filterOptions.SortByID = this.initialparams.SortByID;
					}
					this.filterOptions.SchoolID = this.initialparams.SchoolID;
					this.filterOptions.Criteria = this.initialparams.searchQuery;
				}

				if (this.InputSchoolID > 0) {
					this.filterOptions.SchoolID = this.InputSchoolID;
					this.filterOptions.Criteria = "";
				}

				this.SchoolLoading = false;

				this.onSchoolChanged(this.filterOptions.SchoolID);
				this.onSortByChanged(this.filterOptions.SortByID);

				if (this.AudienceID == 2) {
					//Staff
					//Check SBM Pref
					this.loadSBMOption();
				}
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	loadParameters() {
		this.lstDynamicGroup = [];
		this.lstDynamicGroup = [];
		this.filterOptions = {
			SchoolID: 0,
			StatusID: 1,
			SortByID: 1,
			DynamicGroupValueID: 0,
			DynamicGroup: {
				DynamicGroupID: 0,
				DynamicGroupName: "",
			},
			Criteria: "",
			WorkflowRoleID: -2, //All
		};

		var user: any = this.userService.getCurrentUser();

		this.initialparams = this.localstorageService.getItem("personselector_" + user.userID + "_" + this.AudienceID);

		if (this.initialparams && this.initialparams.StatusID != undefined) {
			this.filterOptions.StatusID = this.initialparams.StatusID;
		}
		if (this.initialparams && this.initialparams.SortByID != undefined) {
			this.filterOptions.SortByID = this.initialparams.SortByID;
		}
		if (this.initialparams && this.initialparams.HideGroupValue != undefined) {
			this.HideGroupValue = this.initialparams.HideGroupValue;
		}
	}
	ngOnInit(): void {
		//this.loadData()

		this.setApplicationItemID();

		this.loadSchoolist(this.applicationItemID);

		this.lstDynamicGroup = [];

		this.audienceIdChangedSubscription = this.personSelectorService.onAudienceIdChange().subscribe((response) => {
			this.AudienceID = response;

			this.loadParameters();
			this.loadSchoolist(this.applicationItemID);
		});

		this.subscription = this.masterService.CheckRouteChange().subscribe((response) => {
			this.setApplicationItemID();

			this.loadParameters();
			this.loadSchoolist(this.applicationItemID);
		});

		this.loadParameters();

		this.personSelectorService.TableRefreshObservable.subscribe((data) => this.TableRefresh(data));
	}

	public onDynamicGroupChange(dynamicGroupID) {
		var result = this.lstDynamicGroup.filter(function (obj) {
			return obj.DynamicGroupID == dynamicGroupID;
		});
		this.filterOptions.DynamicGroup.DynamicGroupID = dynamicGroupID;
		this.filterOptions.DynamicGroup.DynamicGroupName = result[0].DynamicGroupName;
		this.HideGroupValue = result[0].Hide;

		if (this.HideGroupValue == 0) {
			this.loadDynamicGroupValue();
		} else {
			this.filterOptions.DynamicGroupValueID = 0;
			this.filterChanged();
		}
	}

	public onDynamicGroupValueChange(dynamicGroupValueID) {
		this.filterOptions.DynamicGroupValueID = dynamicGroupValueID;
		this.filterChanged();
	}

	public onSchoolChanged(schoolID) {
		var selectedSchool = this.lstSchool.filter(function (obj) {
			return obj.SchoolID == schoolID;
		});

		let school = this.lstSchool[0];
		if (selectedSchool.length > 0) {
			school = selectedSchool[0];
		}

		if (this.UpdateSchoolSelector == true) {
			this.schoolSelectorService.ManuallyUpdateSchool(school);
		}
		this.personSelectorService.setSchool(school);

		this.filterOptions.SchoolID = school.SchoolID;
		if (school.SchoolID > 0) {
			if (this.lstDynamicGroup.length == 0) {
				this.loadDynamicGroup();
			} else {
				//
				// Dynamic Group not in list
				//
				var found = false;
				for (var i = 0; i < this.lstDynamicGroup.length; i++) {
					var next = this.lstDynamicGroup[i];

					if (next.DynamicGroupID == this.filterOptions.DynamicGroup.DynamicGroupID) {
						found = true;
						break;
					}
				}

				if (!found) {
					console.log("Not found");
					this.onDynamicGroupChange(this.lstDynamicGroup[0].DynamicGroupID);
				} else {
					this.loadDynamicGroupValue();
				}
			}
		} else {
			this.HideGroupValue = 1;

			this.filterOptions.DynamicGroupValueID = 0;
			this.filterOptions.DynamicGroup = {
				DynamicGroupID: 0,
				DynamicGroupName: "",
			};
			this.filterChanged();
		}
	}

	public onSortByChanged(SortByID) {
		//SchoolNumber
		//SchoolName
		this.filterOptions.SortByID = SortByID;
		if (SortByID == 1) {
			this.lstSchool.sort((a, b) => (a.SchoolName > b.SchoolName ? 1 : -1));
		} else {
			this.lstSchool.sort((a, b) => (a.SchoolNumber > b.SchoolNumber ? 1 : -1));
		}

		this.filterChanged(true);
	}

	public onStatusChanged(StatusID) {
		this.filterOptions.StatusID = StatusID;
		this.filterChanged();
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscription.unsubscribe();
		this.audienceIdChangedSubscription.unsubscribe();
	}

	filterChanged(notreload?: any) {
		var params = {
			SchoolID: this.filterOptions.SchoolID,
			dynamicGroupValueID: this.filterOptions.DynamicGroupValueID,
			applicationItemID: this.applicationItemID,
			dynamicGroupID: this.filterOptions.DynamicGroup.DynamicGroupID,
			searchQuery: this.filterOptions.Criteria,
			AudienceID: this.AudienceID,
			StatusID: this.filterOptions.StatusID,
			SortByID: this.filterOptions.SortByID,
			dynamicGroupName: this.filterOptions.DynamicGroup.DynamicGroupName,
			HideGroupValue: this.HideGroupValue,
			WorkflowRoleID: this.filterOptions.WorkflowRoleID,
		};
		var user: any = this.userService.getCurrentUser();

		this.localstorageService.setItem("personselector_" + user.userID + "_" + this.AudienceID, params);

		//console.log("Set Local Storage");
		//console.log(params);

		if (!notreload) {
			this.personSelectorService.filterChanged(params);
		}
	}

	TableRefresh(data: any) {
		if (data == "Refresh") {
			// this.personSelectorService.onFilterChange();
			this.filterChanged();
		}
	}

	onWorkflowRoleChange(val) {
		this.filterOptions.WorkflowRoleID = val;

		//Load Data
		// this.personSelectorService.setWorkflowRole(val); //Not implemented yet, might not be needed
		this.filterChanged();
	}

	IsLoading() {
		return this.SchoolLoading == true || this.DynamicGroupLoading == true || this.DynamicValueLoading == true;
	}
}
